import React, { useState, useEffect  } from "react";
import axiosInstance from "../axiosConfig";

const ManualRMIssueForm = () => {
  const convertToIST = (isoDateStr) => {
    const local = new Date(isoDateStr);
    local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
    return local.toISOString().slice(0, 19).replace("T", " ");
  };

  // Hard-coded list of admins
  const adminList = ["VARUN", "Ashwini", "SARFRAZ KHAN","SHOAIB","VIRAT (MAMA)", "ANOOP", "ANWAR", "SONU", "RIYAZ", "IMTIYAZ"];

  const [selectedAdmin, setSelectedAdmin] = useState("");
  const [rows, setRows] = useState([
    {
      itemName: "",
      barcode: "",
      lotNumber: "",
      lotId: "",
     issueDate: new Date().toISOString().slice(0, 16), // returns "2025-05-27T15:41"

      qtyUsed: "",
    },
  ]);

  // useEffect(() => {
  //   axiosInstance.get("/api/admin-list").then((res) => setAdminList(res.data));
  // }, []);

  // On mount, parse the URL’s query string, and if we have rmItemName, barcode, lotId,
  // prefill the first row accordingly:
  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);

  //   const rmItemName = params.get("rmItemName") || "";
  //   const barcode = params.get("barcode") || "";
  //   const lotId = params.get("lotId") || "";

  //   // If any of those exist, replace the initial row with the prefilled one:
  //   if (rmItemName || barcode || lotId) {
  //     setRows([
  //       {
  //         itemName: rmItemName,
  //         barcode: barcode,
  //         lotNumber: "",        // you can leave this blank or fill if you have a param
  //         lotId: lotId,
  //         issueDate: new Date().toISOString().slice(0, 16),
  //         qtyUsed: "",
  //       },
  //     ]);
  //   }
  // }, []);
useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  const rmItemName = params.get("rmItemName") || "";
  const barcode = params.get("barcode") || "";
  const lotNumber = params.get("lotNumber") || "";  // 👈 New param
  const lotId = params.get("lotId") || "";

  if (rmItemName || barcode || lotId) {
    setRows([
      {
        itemName: rmItemName,
        barcode: barcode,
        lotNumber: lotNumber,  // 👈 Added
        lotId: lotId,
        issueDate: new Date().toISOString().slice(0, 16),
        qtyUsed: "",
      },
    ]);
  }
}, []);

  const handleInputChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const addNewRow = () => {
    setRows([
      ...rows,
      {
        itemName: "",
        barcode: "",
        lotNumber: "",
        lotId: "",
        issueDate: new Date().toISOString().slice(0, 16), // returns "2025-05-27T15:41"

        qtyUsed: "",
      },
    ]);
  };

  const removeRow = (indexToRemove) => {
    if (rows.length === 1) return alert("You must have at least one entry.");
    setRows(rows.filter((_, i) => i !== indexToRemove));
  };

  const handleSubmit = async () => {
    if (!selectedAdmin) {
      alert("Please select an User.");
      return;
    }

    try {
      const payload = rows.map((row) => ({
        stockItem: {
          "ITEM NAME": row.itemName,
          BARCODE: row.barcode,
          "LOT NUMBER": row.lotNumber,
          "LOT ID": row.lotId,
          "ISSUE DATE": convertToIST(row.issueDate),
          QTY_USED: row.qtyUsed,
        },
        selectedAdmin: {
          Name: selectedAdmin,
        },
      }));

      for (const entry of payload) {
        await axiosInstance.post("/api/save-rm-issue", entry);
      }

      alert("✅ All RM entries issued successfully.");
      window.location.reload()
      setRows([rows[0]]); // reset form
    } catch (err) {
      console.error("❌ Submission failed:", err);
      alert("❌ Failed to issue RM.");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">RM Issue </h3>

      <div className="mb-3">
        <label className="form-label">Select Name </label>
        <select
          className="form-select"
          value={selectedAdmin}
          onChange={(e) => setSelectedAdmin(e.target.value)}
          required
        >
            <option value="">-- Select Name --</option>
          {adminList.map((admin) => (
            <option key={admin} value={admin}>
              {admin}
            </option>
          ))}
        </select>
      </div>

      {rows.map((row, index) => (
        <div className="card mb-3 p-3" key={index}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="text-muted mb-0">RM Entry #{index + 1}</h6>
            {rows.length > 1 && (
              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => removeRow(index)}
              >
                ❌ Remove
              </button>
            )}
          </div>
          <div className="row g-2">
            <div className="col-md-3">
              <label className="form-label">ITEM NAME</label>
              <input
                type="text"
                className="form-control"
                value={row.itemName}
                onChange={(e) =>
                  handleInputChange(index, "itemName", e.target.value)
                }
                required
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">BARCODE</label>
              <input
                type="text"
                className="form-control"
                value={row.barcode}
                onChange={(e) =>
                  handleInputChange(index, "barcode", e.target.value)
                }
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">LOT NUMBER</label>
              <input
                type="text"
                className="form-control"
                value={row.lotNumber}
                onChange={(e) =>
                  handleInputChange(index, "lotNumber", e.target.value)
                }
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">LOT ID</label>
              <input
                type="text"
                className="form-control"
                value={row.lotId}
                onChange={(e) =>
                  handleInputChange(index, "lotId", e.target.value)
                }
              />
            </div>
            {/* <div className="col-md-3">
              <label className="form-label">ISSUE DATE</label>
              <input
                type="datetime-local"
                className="form-control"
                value={row.issueDate}
                onChange={(e) =>
                  handleInputChange(index, "issueDate", e.target.value)
                }
              />
            </div> */}
            <div className="col-md-2">
              <label className="form-label">QTY USED</label>
              <input
                type="number"
                className="form-control"
                value={row.qtyUsed}
                onChange={(e) =>
                  handleInputChange(index, "qtyUsed", e.target.value)
                }
              />
            </div>
          </div>
        </div>
      ))}

      <div className="d-flex gap-3">
        <button className="btn btn-outline-primary" style={{display:"none"}} onClick={addNewRow}>
          ➕ Add Another RM Entry
        </button>
        <button className="btn btn-outline-success" onClick={handleSubmit}>
          ✅ Submit
        </button>
      </div>
    </div>
  );
};

export default ManualRMIssueForm;
